export default __webpack_public_path__ + "static/media/task_completed.3cd2801b.svg";